import { Collapse, createStyles, Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import { CompletionStatus, CompletionStatusItems } from '../../../services/Model/Outcome'
import DropReason from '../../Outcomes/FormItems/DropReason'
import OutcomeDateItem from '../CustomOutcomeDate/OutcomeDateItem'
import OutcomeDropDownItem from '../CustomOutcomeDropDown/OutcomeDropDownItem'

interface ActivitySectionProps extends WithStyles<typeof styles> {
	requiredEndDate?: boolean
	// requiredStartDate?: boolean
	// startDate?: Date
	onDateChange: (prop: string, value: string) => void
	// maxStartDate?: string
	endDate?: Date
	maxEndDate?: string
	minEndDate?: string
	showEndDate?: boolean
	completionStatus?: CompletionStatus | null
	handleCompletionStatusChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
	dropReason: string
	onDropReasonChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  serviceType?: string
}

const DEFAULT_MAX_DATE = moment()
	.add(2, 'years')
	.format('YYYY-MM-DD')

export const ActivityInformationSection: React.FC<ActivitySectionProps> = (props: ActivitySectionProps) => {
  
	const {
		classes,
		completionStatus,
		dropReason,
		handleCompletionStatusChange,
		// maxStartDate,
		minEndDate,
		onDateChange,
		onDropReasonChange,
		// requiredStartDate,
		requiredEndDate,
		showEndDate,
		endDate,
		// startDate
	} = props
	const compStatus = CompletionStatusItems.find((i) => i.value === completionStatus)
	const isDroppedOut = compStatus && compStatus.label === 'Dropped Out'

  // const getStartDateValue = ()=>{
  //   if(!startDate){
  //     return ''
  //   }
  //   else{
  //     const value =  moment(moment(startDate).format("YYYY-MM-DD")).toDate()
  //     return value
  //   }
  // }

  const getEndDateValue = ()=>{
    if(!endDate){
      return ''
    }
    else{
      const value =  moment(moment(endDate).format("YYYY-MM-DD")).toDate()
      return value
    }
  }

	return (
		<div className={classes.root}>
			<Typography variant="h5" className={classes.sectionSubtitle}>
				Activity Information
			</Typography>
			{/* Removed: Outcome Actual Start Date (outcome.start_date) — no longer collected
			<div>
				<OutcomeDateItem
					label="Participant Start Date"
					required={requiredStartDate}
					prop="startDate"
					value={getStartDateValue()}
					onDateChange={({ target }) => onDateChange('startDate', target.value)}
					maxDate={maxStartDate}
					minDate="1920-01-01"
					containerStyle={{'margin': '0px'}}
					serviceType={props.serviceType}
				/>
			</div>
			*/}
			<div>
				<Collapse
					in={showEndDate}
					style={{ transformOrigin: '0 0 0', flexGrow: 1 }}
					{...(showEndDate ? { timeout: 750 } : {})}
				>
					<OutcomeDateItem
						label="Participant End Date"
						prop="endDate"
						value={getEndDateValue}
						onDateChange={({ target }) => onDateChange('completionDate', target.value)}
						minDate={minEndDate}
						maxDate={DEFAULT_MAX_DATE}
						required={requiredEndDate}
            serviceType={props.serviceType}
					/>
				</Collapse>
			</div>
			<div>
				<OutcomeDropDownItem
					label="Status"
					prop="completionStatus"
					value={compStatus ? compStatus.label : ''}
					onInputChange={handleCompletionStatusChange}
					items={CompletionStatusItems.map((i) => i.label)}
					required={true}
					hideUnknown={true}
					focus={true}
					labelStyle={{'padding': '4px', maxWidth: '25%'}}
					dropDownStyle={{'padding': '4px 0'}}
          serviceType={props.serviceType}
				/>
				<Collapse
					in={isDroppedOut}
					style={{ transformOrigin: '0 0 0', flexGrow: 1 }}
					{...(isDroppedOut ? { timeout: 750 } : {})}
				>
					<DropReason dropReason={dropReason} onChange={onDropReasonChange} required={isDroppedOut} />
				</Collapse>
			</div>
		</div>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		root: {},
		sectionSubtitle: {
			padding: `${theme.spacing.unit}px 0`,
		},
	})

export default withStyles(styles)(ActivityInformationSection)
